import { useEffect } from 'react';
import {
  WebsocketAction,
  LastWebsocketJsonMessageType,
} from '@interfaces/webSocketConnectionInfo';
import { useMytaverseEvent } from '@core/dashboard/providers';
import {
  IExperienceFeatureSettings,
  IMapFeatureFlagsSettings,
} from '@interfaces/event';

export const useHandleEventSettingsMsg = (
  lastJsonMessage: LastWebsocketJsonMessageType,
) => {
  const { setCurrentEvent } = useMytaverseEvent();

  useEffect(() => {
    if (!lastJsonMessage) {
      return;
    }

    const { action } = lastJsonMessage;

    if (action !== WebsocketAction.EventSettingsUpdated) {
      return;
    }

    const features = (lastJsonMessage as any).features as
      | IExperienceFeatureSettings
      | undefined;

    const mapFeatureFlags = (lastJsonMessage as any).mapFeatureFlags as
      | IMapFeatureFlagsSettings
      | undefined;

    if (!features && !mapFeatureFlags) {
      return;
    }

    setCurrentEvent((prev) => {
      if (!prev) {
        return prev;
      }

      return {
        ...prev,
        settings: {
          ...prev.settings,
          ...(features ? { features } : {}),
          ...(mapFeatureFlags ? { mapFeatureFlags } : {}),
        },
      };
    });
  }, [lastJsonMessage, setCurrentEvent]);
};
